import React, { useState, useEffect } from "react";
import { Form, Input, Select, Button, message } from "antd";
import axios from "./Services/Api"; // Ensure Axios is set up properly
import {baseURL} from "./api"

const AddUserForm = ({ loggedInUser }) => {
  const [form] = Form.useForm();
  const [vendors, setVendors] = useState([]);
  const [role, setRole] = useState("");

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          message.error("Authentication token is missing. Please log in.");
          return;
        }

        const response = await axios.get(
          `${baseURL}/getVendor`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setVendors(response.data);
      } catch (error) {
        console.error("Error fetching vendors:", error);
        message.error("Failed to fetch vendors. Please try again.");
      }
    };

    fetchVendors();
  }, []);

  const onFinish = async (values) => {
    const token = localStorage.getItem("token");
    if (!token) {
      message.error("Authentication token is missing. Please log in.");
      return;
    }

    if (
      (role === "vendor" || role === "vendorSale" || role === "employee") &&
      !values.vendorId
    ) {
      message.error("Vendor ID is required for this role.");
      return;
    }

    try {
      const response = await axios.post(
        `${baseURL}/addUser`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 201) {
        message.success("User added successfully!");
        form.resetFields();
      } else {
        message.error("Unexpected response from the server.");
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      message.error("Failed to add user. Please try again.");
    }
  };

  const handleRoleChange = (value) => {
    setRole(value);
  };

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Form.Item name="username" label="Username" rules={[{ required: true }]}>
        <Input placeholder="Enter username" />
      </Form.Item>

      <Form.Item name="password" label="Password" rules={[{ required: true }]}>
        <Input.Password placeholder="Enter password" />
      </Form.Item>

      <Form.Item name="role" label="Role" rules={[{ required: true }]}>
        <Select placeholder="Select role" onChange={handleRoleChange}>
          <Select.Option value="admin">Admin</Select.Option>
          <Select.Option value="vendor">Vendor</Select.Option>
          <Select.Option value="vendorSale">Vendor-Sale</Select.Option>
          <Select.Option value="employee">Employee</Select.Option>
        </Select>
      </Form.Item>

      {(role === "vendor" || role === "vendorSale" || role === "employee") && (
        <Form.Item
          name="vendorId"
          label="Vendor"
          rules={[{ required: true }]}
        >
          <Select placeholder="Select vendor">
            {vendors.map((vendor) => (
              <Select.Option key={vendor._id} value={vendor._id}>
                {vendor.vendorName}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      )}

      <Button type="primary" htmlType="submit">
        Add User
      </Button>
    </Form>
  );
};

export default AddUserForm;
